import { useFormContext } from "react-hook-form";
import { Textarea } from "../ui/textarea";
import { cn } from "@/lib/utils";
import { TemplateMenu } from "@/components/Template/RxTemplates";

export default function QuickNotesSection() {
    const { register, formState } = useFormContext();

    return (
        <div className="space-y-2">
            <div className="relative">
                <Textarea
                    {...register("quick_notes")}
                    placeholder="Add notes..."
                    rows={1}
                    className={cn(
                        // Same box as the Tests / Diagnosis fields above it
                        "text-sm bg-card shadow-none min-h-9 touch:min-h-10 py-[7px] pl-2.5 pr-9 resize-none",
                        "hover:border-ring/60 focus-visible:ring-2 focus-visible:ring-primary/20 focus-visible:border-primary",
                        "placeholder:text-muted-foreground/60 placeholder:font-normal",
                        formState.errors?.quick_notes && "border-b-destructive/60"
                    )}
                    maxLength={300}
                />
                <TemplateMenu type="quick_notes" className="absolute right-1 top-1" />
            </div>
            {formState.errors?.quick_notes && (
                <div className="text-xs text-destructive mt-1">
                    {formState.errors.quick_notes.message as string}
                </div>
            )}
        </div>
    );
}